import { POST } from "../API/post";

export const verifyCaptcha = async (token) => {
    const response = await POST("verify-turnstile", {token});
    return response.status === "Success" ? response : null;
};